export const SALUTATION_LIST = ["Mr", "Mrs", "Ms", "Dr", "Prof"];
